import { useState, useEffect, useContext } from 'react';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import PedidosEditPage from 'pages/pedidos/Edit';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';
import useListPage from 'hooks/useListPage';
import MultiSelectGroup from 'pages/custom/MultiSelectGroup';
import Utils from 'helpers/helper.util';
import useApi from 'hooks/useApi';
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';

const ListaConsumo = (props) => {
    const app = useApp();
    const api = useApi();
    const useutils = useUtils();
    const utils = Utils();
    const { empid, setempid } = useApp();

    const filterSchema = {
        search: {
            tagTitle: "Search",
            value: '',
            valueType: 'single',
            options: [],
        }
    }
    const pageController = useListPage(props, filterSchema);
    const filterController = pageController.filterController;
    const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
    const { filters, setFilterValue } = filterController;
    const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } = pagination;
    const [startDate, setStartDate] = useState(utils.FirstDateOfCurrentMonth());
    const [endDate, setEndDate] = useState(utils.LastDateOfCurrentMonth());
    const [funcionarios, setFuncionarios] = useState([]);
    const [gestorid, setGestorId] = useState(null);
    const [liberacoes, setLiberacoes] = useState([]);

    const fetchLiberacoes = async () => {
        try {
            let endpoint = `pedidos/ListReportConsume/?startdate=${startDate}&enddate=${endDate}`;
            const response = await api.get(endpoint);
            console.log("GESTOR", gestorid);
            setLiberacoes(response.data);
        } catch (error) {
            console.error('Erro ao buscar liberacoes:', error);
        }
    }

    useEffect(() => {
        fetchLiberacoes();
    }, [empid, startDate, endDate]);


    useEffect(() => {
        fetchLiberacoes();
    }, []);


    function ActionButton(data) {
        const items = [
            {
                label: "Editar",
                command: (event) => { app.openPageDialog(<PedidosEditPage isSubPage apiPath={`/pedidos/edit/${data.id}`} />, { closeBtn: true }) },
                icon: "pi pi-pencil"
            },
            {
                label: "Excluir",
                command: (event) => { deleteItem(data.id) },
                icon: "pi pi-trash"
            }
        ]
        let shouldShowButton = data.status == "A";
        return shouldShowButton ?
            (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />)
            : null;
    }


    function bodyId(data) {
        if (data) {
            return (
                <Link to={`/`}> {data.id}</Link>
            );
        }
    }
    function bodyRazaoSocial(data) {
        if (data) {
            return (
                <>{data.empresas_razaosocial}</>
            );
        }
    }

    function bodyFuncionario(data) {
        if (data) {
            return (
                <>{data.funcionarios_nome}</>
            );
        }
    }

    function bodyStatus(data) {
        if (data) {
            return (
                <>
                    <Chip
                        label={
                            app.ChooseItem(
                                data.status,
                                [
                                    { valor: 'A', titulo: 'Aberto' },
                                    { valor: 'C', titulo: 'Cancelado' },
                                    { valor: 'F', titulo: 'Finalizado' }
                                ])
                        }
                    />
                </>
            );
        }
    }

    function bodyTipo(data) {
        if (data) {
            return (
                <><Chip label={
                    app.ChooseItem(
                        data.tipo,
                        [
                            { valor: 'E', titulo: 'Entrada' },
                            { valor: 'S', titulo: 'Saída' },
                            { valor: 'T', titulo: 'Terminal' },
                        ])
                }
                />
                </>
            );
        }
    }

    const OnClickPrintPedido = (param) => {
        if (param) {
            var paramns = { id: 2, filter: `pedido|id|${param.id}|0|0` };
            app.openPageDialog(<app.PrintPreview paramns={paramns} />, { maximized: true, closeBtn: true, width: '80vw' })
        }
    };

    function bodyPrint(data) {
        if (data) {
            let shouldShowButton = data.status == "F";
            return shouldShowButton ? (
                <app.PrintButton onClick={() => OnClickPrintPedido(data)} />
            ) : null;
        }
    }

    function bodyData(data) {
        if (data) {
            return app.FmtDateBR(data)
        }
    }


    function bodyCurr(data) {
        return app.FmtCurr(data)
    }

    function bodyQtde(data) {
        return app.FmtQtd(data)
    }


    function PageLoading() {
        if (loading) {
            return (
                <>
                    <div className="flex align-items-center justify-content-center text-gray-500 p-3">
                        <div><ProgressSpinner style={{ width: '50px', height: '50px' }} /> </div>
                        <div className="font-bold text-lg">Carregando...</div>
                    </div>
                </>
            );
        }
    }
    function EmptyRecordMessage() {
        if (pageReady && !records.length) {
            return (
                <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
                    Nenhum Registro Encontrado
                </div>
            );
        }
    }
    function MultiDelete() {
        if (selectedItems.length) {
            return (
                <div className="m-2 flex-grow-0">
                    <Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Excluir selecionado" />
                </div>
            )
        }
    }
    function ExportData() {
        if (props.exportData && records.length) {
            const downloadFileName = `${useutils.dateNow()}-pedidos`;
            return (
                <div className="m-2">
                    <ExportPageData csv={false} pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="Exportar" tooltip="Exportar" buttonIcon="pi pi-print" />
                </div>
            );
        }
    }
    function PagerControl() {
        if (props.paginate && totalPages > 1) {
            const pagerReportTemplate = {
                layout: pagination.layout,
                CurrentPageReport: (options) => {
                    return (
                        <>
                            <span className="text-sm text-gray-500 px-2">Registros <b>{recordsPosition} do {options.totalRecords}</b></span>
                        </>
                    );
                }
            }
            return (
                <div className="flex-grow-1">
                    <Paginator first={firstRow} rows={limit} totalRecords={totalRecords} onPageChange={onPageChange} template={pagerReportTemplate} />
                </div>
            )
        }
    }
    function PageActionButtons() {
        return (
            <div className="flex flex-wrap">
                <MultiDelete />
                <ExportData />
            </div>
        );
    }
    function PageFooter() {
        if (pageReady && props.showFooter) {
            return (
                <div className="flex flex-wrap">
                    <PageActionButtons />
                    <PagerControl />
                </div>
            );
        }
    }
    function PageBreadcrumbs() {
        if (props.showBreadcrumbs) {
            const items = getPageBreadCrumbs();
            return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
        }
    }
    if (apiRequestError) {
        return (
            <PageRequestError error={apiRequestError} />
        );
    }

    const handleFuncChange = (e) => {
        setGestorId(e.value);
    }

    const headerTemplate = (data) => {
        return (
            <div className="flex align-items-center gap-2">
                <span className="font-bold text-2xl text-primary">{data.employeeName}</span>
            </div>
        );
    };

    const footerTemplate = (data) => {
        return (
            <>
                <td colSpan="12">
                    <div className="flex justify-content-end font-bold w-full">Total de Produtos: {calculateCustomerTotal()}</div>
                </td>
            </>
        );
    };

    const calculateCustomerTotal = () => {
        let total = 0;
        if (liberacoes) {
            for (let liberacao of liberacoes) {
                total += liberacao.quantity + liberacao.localQuantity;
            }
        }
        return total;
    };

    const OnClickList = () => {
        let paramn1 = { id: 6, filter: `v_ped_liberacoes|empid|${6}|0|0` };
        let paramn2 = { id: 6, filter: `v_ped_liberacoes|lib_d|${startDate}|3|0` };
        let paramn3 = { id: 6, filter: `v_ped_liberacoes|lib_d|${endDate}|5|0` };
        let paramns = [paramn1, paramn2, paramn3];
        app.openPageDialog(<app.PrintPreview paramns={paramns} />, { maximized: true, closeBtn: true, width: '80vw' })
    };

    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header="" rowSpan={1} align={'center'} />
                <Column header="Codigo" rowSpan={1} colSpan={2} align={'center'} />
                <Column header="Produto"  align={'center'} />
                <Column header="Estoque" colSpan={2}  align={'center'}/>
                <Column header="" colSpan={4}  align={'center'}/>
                <Column header="Funcionário" colSpan={2}  align={'center'}/>
            </Row>
            <Row>
                <Column header="Data" headerStyle={{ width: '5%' }} align='center'/>
                <Column header="Eletro" headerStyle={{ width: '5%' }}/>
                <Column header="Cliente" headerStyle={{ width: '5%' }}/>
                <Column header="Nome do Produto" headerStyle={{ width: '20%' }}/>
                <Column header="Eletro" headerStyle={{ width: '5%' }}/>
                <Column header="Cliente" headerStyle={{ width: '5%' }}/>

                <Column header="Unit" headerStyle={{ width: '5%' }}/>
                <Column header="Total" headerStyle={{ width: '5%' }}/>
                <Column header="Departamento" headerStyle={{ width: '5%' }}/>
                <Column header="Setor" headerStyle={{ width: '5%' }}/>
                <Column header="Mat" headerStyle={{ width: '5%' }}/>
                <Column header="Nome"/>
            </Row>
        </ColumnGroup>
    );

    return (
        <main id="ListaConsumo" className="main-page">
            {(props.showHeader) &&
                <section className="page-section mb-3">
                    <div className="container-fluid">
                        <div className="grid justify-content-between align-items-center">
                            <div className="col">
                                <Title title="Saidas de Produtos por Periodo" titleClass="text-2xl text-primary font-bold" subTitleClass="text-500" separator={false} />
                            </div>

                            <div className="col-12 md:col-12">

                                <div className="flex gap-3 align-items-center">
                                    <div style={{ minWidth: 220 }}>
                                        <span className="p-input-icon-left w-full">
                                            <i className="pi pi-calendar" />
                                            <label>Data Inicial</label>
                                            <InputText
                                                type="date"
                                                value={startDate}
                                                onChange={(e) => setStartDate(e.target.value)}
                                                placeholder="Data Inicial"
                                                className="w-full"
                                            />
                                        </span>
                                    </div>
                                    <div style={{ minWidth: 220 }}>
                                        <span className="p-input-icon-left w-full">
                                            <i className="pi pi-calendar" />
                                            <label>Data Final</label>
                                            <InputText
                                                type="date"
                                                value={endDate}
                                                onChange={(e) => setEndDate(e.target.value)}
                                                placeholder="Data Final"
                                                className="w-full"
                                            />
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', height: '100%' }}>
                                        <SplitButton
                                            label="Exportar"
                                            icon="pi pi-download"
                                            model={[
                                                {
                                                    label: 'Exportar para PDF',
                                                    icon: 'pi pi-file-pdf',
                                                    command: async () => {
                                                        try {

                                                            api.download(`pedidos/ExportData/export/pdf?startdate=${startDate}&enddate=${endDate}`).then((response) => {
                                                                		const fileName = `saida de produtos por periodo.pdf`;
                                                                        const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                        const link = document.createElement('a');
                                                                        link.href = url;
                                                                        link.setAttribute('download', fileName);
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        link.remove();
                                                                        app.showAppLoading(false);
                                                                    },
                                                                        (response) => {
                                                                            console.error(response);
                                                                            app.showAppLoading(false);
                                                                            alert("Unable to download file")
                                                                        });
                                                        } catch (err) {
                                                            alert('Erro ao exportar PDF');
                                                        }
                                                    }
                                                },
                                                {
                                                    label: 'Exportar para Excel',
                                                    icon: 'pi pi-file-excel',
                                                    command: () => {
                                                        try {

                                                            api.download(`pedidos/ExportData/export/excel?startdate=${startDate}&enddate=${endDate}`).then((response) => {
                                                                		const fileName = `saida de produtos por periodo.xlsx`;
                                                                        const url = window.URL.createObjectURL(new Blob([response.data]));
                                                                        const link = document.createElement('a');
                                                                        link.href = url;
                                                                        link.setAttribute('download', fileName);
                                                                        document.body.appendChild(link);
                                                                        link.click();
                                                                        link.remove();
                                                                        app.showAppLoading(false);
                                                                    },
                                                                        (response) => {
                                                                            console.error(response);
                                                                            app.showAppLoading(false);
                                                                            alert("Unable to download file")
                                                                        });
                                                        } catch (err) {
                                                            alert('Erro ao exportar PDF');
                                                        }
                                                    }
                                                }
                                            ]}
                                            className="p-button-success"
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            }
            <section className="page-section " >
                <DataTable
                    value={liberacoes}
                    dataKey="id"
                    rowGroupMode="subheader"
                    rowGroupHeaderTemplate={headerTemplate}
                    rowGroupFooterTemplate={footerTemplate}
                    headerColumnGroup={headerGroup}
                    groupRowsBy="representative.name"
                >
                    {/*PageComponentStart*/}
                    <Column headerStyle={{ width: '10%' }} field="date"  body={(x) => bodyData(x.date)} align='center'></Column>
                    <Column headerStyle={{ width: '5%' }} field="externalCode" align='center'></Column>
                    <Column headerStyle={{ width: '5%' }} field="productId" align='center'></Column>
                    <Column headerStyle={{ width: '40%' }} field="productName" align='left'></Column>
                    <Column headerStyle={{ width: '5%' }} field="quantity" align='right' body={(x) => bodyQtde(x.quantity)}></Column>
                    <Column headerStyle={{ width: '5%' }} field="localQuantity" align='right' body={(x) => bodyQtde(x.localQuantity)}></Column>

                    <Column headerStyle={{ width: '5%' }} field="unit" body={(x) => bodyCurr(x.unit)} align='right' ></Column>
                    <Column headerStyle={{ width: '5%' }} field="total" body={(x) => bodyCurr(x.total)} align='right'></Column>
                    <Column headerStyle={{ width: '5%' }} field="department" align='right'></Column>
                    <Column headerStyle={{ width: '5%' }} field="sector" align='right'></Column>
                    <Column headerStyle={{ width: '5%' }} field="registration" align='center'></Column>
                    <Column headerStyle={{ width: '5%' }} field="name" align='left'></Column>

                </DataTable>
                {/* <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '1rem' }}>
                    {liberacoes.length > 0 && (
                        <app.PrintButton onClick={() => OnClickList()} label="Imprimir Listagem" />
                    )}
                </div> */}
                <PageFooter />

            </section>
        </main>
    );
}
ListaConsumo.defaultProps = {
    primaryKey: 'id',
    pageName: 'ListaConsumo',
    apiPath: 'pedidos/index',
    routeName: 'ListaConsumoList',
    msgBeforeDelete: "Tem certeza de que deseja excluir este registro?",
    msgTitle: "Apagar registro",
    msgAfterDelete: "Registro excluído com sucesso",
    showHeader: true,
    showFooter: true,
    paginate: true,
    isSubPage: false,
    showBreadcrumbs: true,
    exportData: false,
    importData: false,
    keepRecords: false,
    multiCheckbox: true,
    search: '',
    fieldName: null,
    fieldValue: null,
    sortField: '',
    sortDir: '',
    pageNo: 1,
    limit: 10,
}

export default ListaConsumo;